import {STATIC_BUCKET_PATH} from "../../../utils/const";

const keyToIconUrl = {
  magento: `${STATIC_BUCKET_PATH}/merchant-images/magento.svg`,
  flutter: `${STATIC_BUCKET_PATH}/merchant-images/flutter.svg`,
  ios: `${STATIC_BUCKET_PATH}/merchant-images/ios.svg`,
  opencart: `${STATIC_BUCKET_PATH}/merchant-images/opencart.svg`,
  android: `${STATIC_BUCKET_PATH}/merchant-images/android.svg`,
  woocommerce: `${STATIC_BUCKET_PATH}/merchant-images/woo.svg`,
  bigCommerce: `${STATIC_BUCKET_PATH}/merchant-images/bigc.svg`,
  weebly: `${STATIC_BUCKET_PATH}/merchant-images/weebly.svg`,
  square: `${STATIC_BUCKET_PATH}/merchant-images/square.svg`,
  wix: `${STATIC_BUCKET_PATH}/merchant-images/wix.svg`,
  ecwid: `${STATIC_BUCKET_PATH}/merchant-images/ecwid1.svg`,
  react: `${STATIC_BUCKET_PATH}/merchant-images/react.svg`,
  angular: `${STATIC_BUCKET_PATH}/merchant-images/angular.svg`,
  vue2: `${STATIC_BUCKET_PATH}/merchant-images/vue.svg`,
  vue3: `${STATIC_BUCKET_PATH}/merchant-images/vue.svg`,
  javascript: `${STATIC_BUCKET_PATH}/merchant-images/javascript.svg`,
  reactNative: `${STATIC_BUCKET_PATH}/merchant-images/react-native.svg`,
  ionic: `${STATIC_BUCKET_PATH}/merchant-images/ionic.svg`,
};
export default keyToIconUrl;
